const testimonials = [
  {
    name: "Marcus T.",
    location: "Lee's Summit, MO",
    stars: 5,
    text: "Our family trip to Cancún was three weeks away when I realized my son's passport had expired. Fast Passport Center had a new one in 72 hours. Saved the trip completely.",
    role: "Lee's Summit resident",
  },
  {
    name: "Jennifer K.",
    location: "Blue Springs, MO",
    stars: 5,
    text: "I needed an emergency renewal before a business trip to Toronto. No KC agency appointments available. Fast Passport Center got it done in 48 hours with zero stress.",
    role: "Corporate account manager",
  },
  {
    name: "David R.",
    location: "Grain Valley, MO",
    stars: 5,
    text: "As a Longview CC professor who leads study abroad trips, I've used Fast Passport Center for three consecutive years. Always reliable, always faster than I expect.",
    role: "Longview Community College faculty",
  },
  {
    name: "Stephanie M.",
    location: "Lee's Summit, MO",
    stars: 5,
    text: "Lost my passport two weeks before our Jamaica honeymoon. The team walked me through the DS-64 process and had a replacement in 4 days. Genuinely lifesaving.",
    role: "Newlywed traveler",
  },
];

export default function LeeSummitTestimonialsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Real Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Lee&apos;s Summit &amp; Jackson County Travelers Say
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-6">
              <div className="flex items-center gap-0.5 mb-3">
                {Array(t.stars).fill(null).map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#F6C344] text-sm"></i>
                ))}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">&ldquo;{t.text}&rdquo;</p>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <span className="text-white font-bold text-sm">{t.name[0]}</span>
                </div>
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location} &middot; {t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}